










import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Size, Color } from "../../../../../../../base/domain/drawing";
import { IConfiguration } from "../../../../../../domain/configuration";
import { instanceOfIRectangleCoordinateEditable, instanceOfIPresentableFixedAspectRatio } from "../../../../../../domain/editableFormat/properties";
import { FormatObjectPropertyEditor } from "../contents";
import { NewObjectLocatableMixin } from "./mixins";

@Component({
  components: {
    FormatObjectPropertyEditor,
  },
})
export default class RectangleObjectLocator extends Mixins(NewObjectLocatableMixin) {
  @Prop()
  pallet: Color[];

  @Prop()
  shouldStamp: boolean;

  @Prop()
  stampSize: Size;

  $configuration!: IConfiguration;

  mounted(): void {
    this.start();
  }

  start(): void {
    if (!this.shouldStamp) {
      this.process = () => this.layoutRectangle(this.minSize.width, this.minSize.height, this.fixedAspectRatio);
    } else {
      this.startStamp();
    }
  }

  get minSize() {
    return this.$configuration.formatEditor.behavior.format.editor.object.size.min;
  }

  get fixedAspectRatio(): number {
    if (!instanceOfIRectangleCoordinateEditable(this.editor) || !instanceOfIPresentableFixedAspectRatio(this.editor) || !this.editor.isAspectRatioFixed()) {
      return 0;
    }
    const size = this.editor.size().getValue();
    return size.width > 0 && size.height > 0
      ? size.width / size.height
      : 0;
  }

  startStamp(): void {
    if (!instanceOfIRectangleCoordinateEditable(this.editor)) {
      return;
    }
    this.editor.size().setValue(this.stampSize);
    this.process = () => this.locate();
  }

  @Watch("stampSize")
  onStampSizeChanged(newValue: Size): void {
    this.start();
  }
}
